// istanbul ignore file  # Not needed to test this file
import { createRemoteModule } from '@makemydeal/dr-shared-components';
import type { FunctionComponent } from 'react';
import type { FindOrCreateProps } from './types/FindOrCreateProps';

export const FindOrCreateModule: FunctionComponent<FindOrCreateProps> = createRemoteModule<FindOrCreateProps>(
    'customer',
    './FindOrCreateModule'
);
